import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store';
import { _isMobile, _isApp } from '@/utils'
import routesH5 from './routesH5'
import routesPC from './routesPC'
import { has, isEmpty } from 'lodash-es'
import * as API from '@/api'
import { useStorage } from 'vue3-storage'
import { Toast } from 'vant';
import { promoteUrl } from "@/utils/url";
import { homeCategoryTable, forumCategoryTable } from "@/composable/commonFunction/categoryTable";

const storage = useStorage()

const isH5View = !!_isMobile() || !!_isApp()
const routes = [

  // ---------------------------------------
  // 个别定义 PC 与 H5 的 routes, 依装置判断引入
  ...isH5View ? routesH5 : routesPC,

  // ---------------------------------------
  // 共用页面:
  {
    // for iframe
    path: '/palcodePopup',
    name: 'palcodePopup',
    components: {
      default: () => import('@/components/popup/PalcodePopup'),
    },
    meta: {
      title: '推荐好友',
      keepAlive: true
    }
  },
  {
    // for iframe
    path: '/palcodeSuccessPopup',
    name: 'palcodeSuccessPopup',
    components: {
      default: () => import('@/components/popup/PalcodeSuccessPopup'),
    },
    meta: {
      title: '推荐好友:温馨提示',
      keepAlive: false // true 在 router 跳转时会报错 parentComponent.ctx.deactivate is not a function
    }
  },
  /**
    @example: 403
    {
      path: '/403',
      name: '403',
      components: {
        default: () => import('@/views/403vue')
      },
      meta: {
        title: '403'
        layout: 'layoutDefault'
      }
    }
    @example: RWD
    {
      path: '/example-rwd',
      name: 'example-rwd',
      components: {
        default: () => import('@/views/rwd.vue'),
      },
      meta: {
        title: '范例: 不分装置',
        layout: 'layoutDefault'
      }
    }
  */
  // ---------------------------------------
  // {
  //   path: '/test',
  //   name: 'test',
  //   components: {
  //     default: () => import('@/views/test/TestView'),
  //   },
  //   meta: {
  //     title: '测试页面',
  //     keepAlive: true
  //   }
  // },
  // ---------------------------------------
  /**
   * 导页至 login 页面
   * */
  {
    path: "/redirectToLogin",
    name: 'redirectToLogin',
    components: {
      default: () => import('@/views/redirect/RedirectToLoginView'),
    },
    beforeEnter(to, from, next) {
      window.location.href = promoteUrl() + '/member_vue.php?platform=2&method=login&back=' + encodeURIComponent(document.URL);
    }
  },
  /**
   * 导页
   * */
  {
    path: "/redirect",
    name: 'redirect',
    components: {
      default: () => import('@/views/redirect/RedirectView'),
    },
    beforeEnter(to, from, next) {
      Toast({
        message: '权限不足!',
        duration: 600,
        onClose: () => {
          if (history.length > 1) history.back()
          else next({ name: home })
        }
      })
    }
  },
  /**
   * 未设定路径处里
   * @see https://router.vuejs.org/guide/migration/#removal-of-the-fallback-option
   * @see https://router.vuejs.org/guide/essentials/dynamic-matching.html#catch-all-404-not-found-route
   * @desc 可导至首页, 或是前往 NotFound 页面
   * */
  {
    path: "/:pathMatch(.*)*",
    redirect: '/'
  }
]

// 首頁查詢參數forum校驗
const validateHomeParam = (queryForumId) =>{
  const forumIdList = homeCategoryTable.map(item=>item.val).concat([''])
  queryForumId = !queryForumId ? '' : +queryForumId ? +queryForumId : undefined;
  return forumIdList.includes(queryForumId)
}

//圈子頁(/forum)下的參數校驗 , 官方和老哥修車可不帶type
const validateForumParam = (to)=>{
  const forumCategory = JSON.parse(JSON.stringify(forumCategoryTable))
  const fid   = +to.params.fid || undefined;
  const type  = to.params.type || undefined;
  const specificFidList = [41, 42, 43, 52, 63] //官方和老哥修車的fid
  let params
  if(specificFidList.includes(fid)) {
    params = forumCategory.filter(item=>item.fid === fid)
  }else if(!type) {
    params = forumCategory.filter(item=>item.top && item.fid === fid)
  } else {
    params = forumCategory.filter(item=>item.type === type && item.fid === fid)
  }
  return params.pop() || undefined;
}

// 是否需要登入驗證
const requireAuth = (forumId, previousForumId)=>{
  const headerCategoryData = homeCategoryTable.filter(item=>item.val === +forumId)[0]
  previousForumId = !previousForumId
    ? homeCategoryTable.filter(item=>item.home)[0]['val']
    : previousForumId;
  if(headerCategoryData && headerCategoryData.requireAuth && !store.state.user.isLogin) {
    const url = document.URL.replace(/(forum=\d+)/,'forum=' + previousForumId)
    window.location.replace(promoteUrl() + '/member_vue.php?platform=2&method=login&back=' + encodeURIComponent(url))
    return false;
  }
  return true;
}

// 在PC端貼上H5的推薦-老哥 推薦-老姐 推薦-官方 推薦-爆獎 推薦-雜談時跳轉到 /forum
// 必須在參數校驗下面才做
const pcRedirectToForumRoute = (to, from, next) =>{
  const platform = store.getters.isH5View ? 'H5' : 'PC';
  if(platform === 'H5' || !to.query.forum) {
    return;
  }
  const recommendForum = homeCategoryTable
    .filter(item=>!['recommend', 'ranking', 'follow', 'all'].includes(item.key))
    .filter(item=>item.val === +to.query.forum)
  if(!recommendForum.length) {
    return
  }
  const forum = forumCategoryTable.filter(item=>item.top && item.key.split('-')[0] === recommendForum[0]['key'])[0]
  next({ name:'forum', params:{ fid:forum.fid, type:forum.type }})
  return
}

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {

  // render DOM
  document.title = to.meta.title || '抖圈 - 为du而生'

  // 交給網關儲存palcode、refurl等cookie
  let palcode = to.query.palcode
  let refurl = to.query.refurl
  if (palcode || refurl) {
    let params = {
      'palcode': palcode || '',
      'refurl': refurl || ''
    }
    API.initAPI(params)
  }

  // on first load:
  // get the data that need to check before router's next()
  const { isLogin } = await store.dispatch('firstLoadHandler')

  const platform = store.getters.isH5View ? 'H5' : 'PC'

  if (to.name === 'home') {
    // 參數校驗
    if(!validateHomeParam(to.query.forum)) {
      next({ name: 'Error404', params:{ catchAll: '404' }, replace: true })
      return;
    }
    // 檢查是否需要登入驗證
    if(!requireAuth(to.query.forum, from.query.forum)) {
      return
    }
    pcRedirectToForumRoute(to, from, next)
    next()
    return;
    // on home page
    // let redirectTo
    // if(platform === 'H5'){
    //   redirectTo = 1
    //   // 參數校驗
    //   if(!validateHomeParam(to.query.forum)) {
    //     next({ name: 'Error404', params:{ catchAll: '404' }, replace: true })
    //     return;
    //   }
    // } else {
    //   redirectTo = await store.dispatch('forum/homePageHandler', { to, from })
    // }

    // if (isEmpty(redirectTo)) next()
    // else next(redirectTo)
  } else if(to.name === 'forum') {
    const params = validateForumParam(to)
    if(!params) {
      next({ name: 'Error404', params:{ catchAll: '404' }, replace: true })
      return;
    } else if(!to.params.type) {
      next({ name:'forum', params:{ fid: to.params.fid, type: params.type }})
      return;
    }
    next()
    return;
  }
  else {
    // -----------------------------------------------
    // check page's auth
    if (to.meta.requiresAuth) {
      const isCheckAdmin = to.meta.auth?.isAdmin || false
      const isAdmin = store.state.user.isAdmin
      if (isCheckAdmin && !isAdmin) {
        next('/redirect') // 导页
      } else if (!isLogin) {
        next('/redirectToLogin') // 导去登入页面
        return
      } else {
        const isMeOnly = to.meta.auth?.isMeOnly || false
        const isNotMe = to.params?.userId !== store.getters['user/userId']
        if (isMeOnly && isNotMe) {
          next('/redirectToLogin') // 导去登入页面
        }
        else next()
      }
    } else next()
  }
})

router.afterEach((to, from, failure) => {
  store.dispatch('common/handleLoading', false)
})

export default router
